import { useEffect, useState } from 'react';
import { META_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import { getLocale } from '../helpers/locales';
import { IMeta } from '../types/widget';

interface State {
  meta?: IMeta;
  sector?: {
    label: string;
  };
  locale?: any;
}

const useNav = ({ i18n }) => {
  const { Widget } = window;
  const [state, setState] = useState<State>({
    meta: Widget.metaController.meta,
    sector: null,
    locale: null,
  });
  const { selectedDate } = Widget.metaController;

  useEffect(() => {
    Widget.metaController.addListener(META_EVENTS.CHANGE_SECTOR, changeSector);
    Widget.metaController.addListener(META_EVENTS.INIT, setMeta);

    getCurrentLocale(i18n.language);

    return () => {
      Widget.metaController.removeListener(META_EVENTS.CHANGE_SECTOR, changeSector);
      Widget.metaController.removeListener(META_EVENTS.INIT, setMeta);
    };
  }, []);

  const setMeta = () => {
    setState((prevState) => ({
      ...prevState,
      meta: Widget.metaController.meta,
    }));
  };

  const changeSector = (sector) => {
    setState((prevState) => ({
      ...prevState,
      sector,
    }));
  };

  const getCurrentLocale = async (lang: string) => {
    const locale = await getLocale(lang);

    setState((prevState) => ({ ...prevState, locale: locale.default }));
  };

  return { state, selectedDate };
};

export default useNav;
